import { AxiosResponse } from 'axios'
import { axiosWithImitator } from '../withAuth'

const getAllUpdates = async (
    type?: 'UnderOpdatering' | 'FaerdigBehandlet'
): Promise<AxiosResponse> => {
    let data = {}

    if (type) {
        data = {
            params: {
                'request.opdateringBatchStatus': type,
            },
        }
    }

    const response = axiosWithImitator.get(
        `/opdatering/hentegnemedlemmeropdateringerlist`,
        data
    )
    return response
}

const getAllWorkplaces = (): Promise<AxiosResponse> => {
    const response = axiosWithImitator.get(
        '/medlem/hentegnemedlemmerprarbejdsstedprtrhverv'
    )

    return response
}

const getUpdateDetails = (batchId: string): Promise<AxiosResponse> => {
    const response = axiosWithImitator.get(
        '/opdatering/hentopdateringbatchdetalje',
        {
            params: {
                'request.opdateringBathcId': batchId,
            },
        }
    )

    return response
}

export { getAllUpdates, getAllWorkplaces, getUpdateDetails }
